import React from 'react';

export default function DisabledMicrophoneIcon(props) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='evenodd'
                d='M9.748 7.65l.08.082 2.214 2.624.001-.177a2.567 2.567 0 1 1 5.135 0v4.258c0 .543-.169 1.046-.456 1.46l.95 1.126c.138-.165.26-.343.368-.534a4.12 4.12 0 0 0 .509-1.874l1.377-.001v-.015l-.003.125a5.483 5.483 0 0 1-.683 2.441 4.978 4.978 0 0 1-.669.923l1.044 1.236c.3.356.282.878-.026 1.212l-.077.074a.897.897 0 0 1-1.194-.02l-.08-.082-.694-.823L8.286 8.628a.92.92 0 0 1 .191-.925l.077-.073a.897.897 0 0 1 1.194.02zm.92 6.964l.003.097c.039.656.211 1.258.504 1.778a3.572 3.572 0 0 0 1.37 1.37 4.02 4.02 0 0 0 1.505.48l1.156 1.38c-.197.02-.396.03-.598.03-1.001 0-1.935-.237-2.74-.69a4.95 4.95 0 0 1-1.893-1.894 5.507 5.507 0 0 1-.687-2.55l1.38-.001z'
                opacity='.198'
            />
        </svg>
    );
}
